import React from 'react';
import { Label, } from 'components'
import { formatParkingType, } from 'helpers/helpers'
import PropTypes from 'prop-types'
import {
  colors,
} from '@material-ui/core'
import { STANDARD, FREE, GREEN, USER, } from 'constants/parkingTypes'

const ParkingType = (props) => {
  const { type, } = props

  const typeColors = {
    [STANDARD]: colors.red[600],
    [FREE]: colors.orange[600],
    [GREEN]: colors.green[600],
    [USER]: colors.green[600],
  }

  return (
    <Label
      color={typeColors[type]}
      variant="outlined"
    >
      {formatParkingType(type)}
    </Label>
  )
}

ParkingType.propTypes = {
  type: PropTypes.number,
};

export default ParkingType
